import { interceptor } from "./interceptor";

export const getSessionTokenService = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v1/auth/get-session-token";
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    showMsg: false,
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
export const getAccessTokenService = async (userInput) => {
  const { headers, body } = userInput;
  console.log(userInput);
  const url = "/v1/auth/get-access-token";
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    showMsg: false,
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const SendAdharOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  console.log(userInput);
  const url = "/v3/abha/send-aadhar-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const VerifyAdharOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/verify-aadhar-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const SendMobileOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/sendMobileOtp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
export const VerifyMobileOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/verifyMobileOtp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const abhaSuggestionsServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/getAbhaSuggestions";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
export const abhaCreateServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/createAbhaAddress";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
export const abhaCartDownloadServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/downloadAbhaCard";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const generateAbhaSessionServices = async () => {
  const url = "/v3/abha/generateAbhaSession";
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    showMsg: false,
  };
  // if (Object.keys(body).length > 0) {
  //   options.body = JSON.stringify(body);
  // }
  const response = await interceptor(url, options);

  return response;
};

export const MobileOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/external/send-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const mobileOtpVerifyServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/external/verify-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };

  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await interceptor(url, options);
    return response;
  } catch (error) {
    console.error("OTP verification failed:", error);
    throw error;
  }
};

export const UpdateAbhaUserServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/external/update-user";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
